<upp-kb-input #input 
    [ngClass]="{ 'title': (value !== null) }"
    [ngStyle]="{ 'margin-bottom': errors ? '15px' : '0px' }"
    [type]="type" 
    [kiosk]="kiosk" 
    [name]="formControlName" 
    [placeholder]="placeholder" 
    [value]="value" 
    [readonly]="readonly"      
    [disabled]="_disabled" 
    (Focused)="onFocus()" 
    (Changed)="value = $event"
    [autocomplete]="autocomplete">
</upp-kb-input>
<ion-label class="input-title" [ngClass]="{ 'hide': !showTitle }">{{viewTitle}}</ion-label>
<upp-er-input *ngIf="formGroup"
    [form]="formGroup"
    [name]="formControlName" 
    [value]="value"
    [errornfo]="errornfo">
</upp-er-input>
